<template>
    <div class="v-atlas-direct-feature-info">
        <div>
            <PropertyGrid :object="props.feature.properties" :config="propertyGridConfig" />
        </div>
    </div>
</template>

<script setup lang="ts">


import { PropertyGrid, ViewStackController } from "gertrud";

import { SimpleGeodataMapModule } from "../mapModules/simpleGeodata/SimpleGeodataMapModule";
import { PropertyGridConfig } from "gertrud";

const props = defineProps<{
    feature: GeoJSON.Feature,
    mapModule: SimpleGeodataMapModule
    viewStackController: ViewStackController
}>()

const propertyGridConfig: PropertyGridConfig = {
    fields: {}
}

</script>
